<template>
	<div class="row" v-if="groups.length > 0">

		<div class="panel panel-primary">
		    <div class="panel-heading">
				<h3 class="panel-title">{{ tableTitle }}</h3>
		    </div>
		    <table class="table table-bordered table-striped">
		    	<thead>
		    		<tr>
		    			<th class="row-actions row-actions-2-btn">&nbsp;</th>
		    			<th>Group</th>
		    			<th>Email Address</th>
						<th class="text-center">Members</th>
						<th class="text-center">Capacity</th>
						<th class="text-center">Spaces</th>
		    			<th>Members</th>
		    		</tr>
		    	</thead>
		    	<tbody>
		    	<tr v-for="(group,index) in groups">
		    		<td class="row-actions row-actions-2-btn">
		    			<button class="btn btn-danger btn-sm" @click="handleDelete(index, group)"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></button>
		    			<!-- <button class="btn btn-primary btn-sm" @click="handleEdit(index, group)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button> -->
		    			<button class="btn btn-primary btn-sm" @click="editGroupMemberForm(group)"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button>
		    		</td>
		    		<td>
		    			<span v-show="editingIndex != index">{{ group.name }}</span>
    					<form @submit.prevent="updateGroup()">
		    			<input v-show="editingIndex == index" type="text" :id="'item-group-' + index" class="form-control" v-model="form.name"  @keydown.enter="updateGroup()" @keydown.esc="cancelEditing()" />
	    				</form>
	    				<td><a :href="'mailto:' + group.email_address.email_address">{{ group.email_address.email_address }}</a>
					</td>
						<td class="text-center">{{ group.member_count }}</td>
						<td class="text-center">{{ group.capacity }}</td>
						<td class="text-center">{{ group.spaces }}</td>
		    		
					<td>{{ group.member_names }}</td>
		    	</tr>
		    </tbody>
		    </table>
			<vuedal @group-members-changed="updateMembers"></vuedal>

		</div>


	</div>

	
</template>



<script>
    import Form from '../utils/Form';
	import Vue from 'vue';
	import { default as Vuedals, Component as Vuedal, Bus as VuedalsBus } from 'vuedals';

	Vue.use(Vuedals);

    import _ from 'lodash';
	import { Table } from 'element-ui';
	import lang from 'element-ui/lib/locale/lang/en';
	import locale from 'element-ui/lib/locale';
	locale.use(lang);

	export default {
		components: { Table, Vuedal },
        props: {
            title: {
                type: String,
                default: "Groups"
            },
            can_manage_groups: {
            	type: Boolean,
            	default: false
            }
        },
		data: function () {
				return {
					tableTitle: this.title,
					canManageGroups: this.can_manage_groups,
					memberFilterOptions: null,
					groups: [],
					members: [],
					editingIndex: -1,
					editingGroup: {},
	                form: new Form({
	                    name: this.editingGroup ? this.editingGroup.name : null
	                })
			}
		},
		computed: {
            recordFilters : function() {
                var filters = [];
                return 'filters=' + filters.join();
            }
		},
		mounted() {
			console.log('Group List component mounted.');
			this.refreshGroupList();
			this.getMembers();
			window.eventBus.$on('add-new-group', this.refreshGroupList);
		},
		methods: {
            refreshGroupList() {
				console.log('refreshGroupList');
				// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
				axios.get('/api/v1/groups?'+ this.recordFilters).then((response) => {
					// this.loadingInstance.close();
					console.log(response.data);
					this.groups = response.data;
				}).catch((error) => {
					// this.loadingInstance.close();
					console.log(error);
					this.$message({message: 'There was a problem loading groups.', type: 'error'});
				});
			},

			formatDate(theDate) {
				return moment(theDate).format("DD/MM/YYYY")
			},

			elFormatDate(row, column) {
				return moment(row.swim_date).format("DD/MM/YYYY")
			},
			setMemberFilterOptions() {
				var memberFilterOptions = _.sortBy(this.Groups,['member.last_name', 'member.first_name']).map(function(squad)
				{ 
					console.log(group.event.id);
					console.log(clubRecord.event.name);
					return { text: clubRecord.event.name, value: clubRecord.event.id, stroke: clubRecord.event.stroke, distance: clubRecord.event.distance};
				});
				this.eventFilterOptions = _.uniqBy(eventFilterOptions, 'value');
			},

			filterMember(value, row) {
				return row.member.id === value;
			},
			handleDelete(index, record) {
				console.log('Deleting record: ' + record.id);
				axios.delete('/api/v1/groups/' + record.id).then((response) => {
					// this.loadingInstance.close();
					console.log(response.data);
					this.refreshGroupList();
					this.$message({message: 'The group has been deleted.', type: 'success'});
				}).catch((error) => {
					// this.loadingInstance.close();
					this.$message({message: 'There was a problem deleting the group.', type: 'error'});
				});
			},
			handleEdit(index, record) {
				console.log('Editing record: ' + record.id);
				console.log('Index: ' + index)
				console.log(record);
				this.editingIndex = index;
				this.editingGroup = record;
				this.form = new Form({
                    name: record.name,
                })


			},
            updateGroup() {
        		console.log('updateGroup');
        		this.groups[this.editingIndex].name = this.form.name;
                this.form.put(`/api/v1/groups/${this.editingGroup.id}`)
                .then(response => {
                    this.$emit('group-changed');
                    console.log(response);
                    this.cancelEditing();
                    this.refreshGroupList();
                })
                .catch(error => {
                	console.log(error);
                    this.$message({message: 'There was a problem saving the group.', type: 'error'});
                });
            },
            cancelEditing() {
		      this.editingIndex = -1;
		      this.editingGroup = {};
		      this.form = new Form({});
            },
			sortEvent(a, b) {
		        if (a.event.stroke == b.event.stroke) {
		        	if (a.event.distance > b.event.distance) {
		        		return 1;
		        	}
		        	else if (a.event.distance < b.event.distance) {
		        		return -1
		        	}
		        }
		        else if (a.event.stroke > b.event.stroke) {
		        	return 1;
		        }
		        else if (a.event.stroke < b.event.stroke) {
		        	return -1;
		        }
		        return 0;
			},
            editGroupMemberForm(group) {
            	console.log('editGroupMemberForm');
            	console.log('Group ID: ' + group.id);
            	this.$vuedals.$emit('new', {
                    name: 'edit-group',
                    title: 'Edit Group',
                    props: {
                        group: group,
                        memberOptions: this.members
                    },
                    component: 'edit-group-form'
                });
            },
            getMembers() {
                // axios.get(`/api/v1/timeslots/${this.timeslotId}/members`)
                axios.get(`/api/v1/members`)
                    .then(response => {
                        this.members = response.data;
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem fetching members.', type: 'error'});
                        console.log(error);
                    });
            },
            updateMembers(event) {
            	console.log('updateMembers');
            	this.refreshGroupList();
            	console.log(event)

            }
		}
	}
</script>
